module.exports = {
    props: ['user', 'team'],

    /**
     * The component's data.
     */
    data() {
        return {
            token: '',
            form: new SparkForm({

            })
        };
    },


    /**
     * Prepare the component.
     */
    mounted() {

    },


    methods: {
        /**
         * Update the team name.
         */
        generateToken() {
            Spark.put(`/settings/${Spark.teamsPrefix}/${this.team.id}/generateToken`, this.form)
                .then((response) => {
                    this.token = response.token;

                    Bus.$emit('updateTeam');
                    Bus.$emit('updateTeams');
                });
        }
    }
};
